import type { RefObject } from 'react';
import { useEffect, useRef } from 'react';

export function useFirstRenderRef() {
  const firstRender = useRef(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      firstRender.current = false;
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, []);

  return firstRender;
}

// Children share SectionContainer's ref so a remounted panel (e.g. back from Summary) doesn't restart the window.
// Read through a hook: a direct `.current` read in render makes the React Compiler skip the calling component.
export function useIsFirstRender(firstRenderRef: RefObject<boolean>) {
  return firstRenderRef.current;
}

export default function useFirstRender() {
  return useIsFirstRender(useFirstRenderRef());
}
